import api from "../config/apiConfig";
import { getSelectedCompany, getUserDetails } from "../utils/auth";
import { getAdminId, getRegisterId } from "../utils/authId";
import { toast } from "react-toastify";

export const viewEmployee = async (data) => {
  const id = getRegisterId() || {};
  const role = getUserDetails() || {};
  try {
    const response = await api.get(
      `api/get_all_employee/?admin=${id}&other_user=${role.role}${data} `,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addUser = async (formData) => {
  const id = getAdminId();
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...formData,
    admin_id: id,
    role: "staff",
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.post("api/emp_registration/", data);
    if (response) {
      toast.success("Registeration successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {
    throw error.response.data;
    // console.log("error");
  }
};

export const editUser = async (formData) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const id = getAdminId();
  const data = {
    ...formData,
    admin_id: id,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(
      `api/update_employee/${formData.row_id}/`,
      data
    );
    if (response) {
      toast.success("Update successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {
    throw error.response.data;
  }
};

export const updateEmployeeStatusApi = async (formData) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...formData,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(`api/active_deactive_employee/`, data);
    if (response) {
      toast.success("Update successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {}
};

//Fetch Selected User

export const FetchSelectedUserApi = async (data) => {
  try {
    const response = await api.get(`api/selected_employee_details/${data}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
